(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-side-panel-asset"] && !Shopify.designMode) return;
  try {
    (function () {
    // Global guards across renders
    window.__sidePanelInit = window.__sidePanelInit || {};
    window.__sidePanelOpenCount = window.__sidePanelOpenCount || 0;

    function wireSidePanel(openBtnId, dialogId, root = document, controller) {
      const openBtn = root.getElementById ? root.getElementById(openBtnId) : document.getElementById(openBtnId);
      const dialog = root.getElementById ? root.getElementById(dialogId) : document.getElementById(dialogId);
      if (!dialog || !openBtn) return;

      if (dialog.dataset.sidePanelInit === 'true') return;
      if (window.__sidePanelInit[dialogId]) return;

      const signal = controller?.signal;

      function openDialog() {
        try {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
            document.documentElement.style.overflow = 'hidden';
          }
        } catch (e) { /* already open; ignore */ }
        if (window.__sidePanelOpenCount === 0) document.body.classList.add('no-scroll');
        window.__sidePanelOpenCount++;
      }

      function closeDialog() {
        if (typeof dialog.close === 'function') dialog.close();
        else {
          dialog.removeAttribute('open');
          document.documentElement.style.overflow = '';
        }
        window.__sidePanelOpenCount = Math.max(0, window.__sidePanelOpenCount - 1);
        if (window.__sidePanelOpenCount === 0) document.body.classList.remove('no-scroll');
      }

      // Backdrop click (click outside the panel)
      dialog.addEventListener('click', (e) => {
        const panel = dialog.querySelector('.side-panel__panel');
        if (panel && !panel.contains(e.target)) closeDialog();
      }, { signal });

      // Close buttons
      dialog.querySelectorAll('[data-close-dialog]').forEach((btn) => {
        btn.addEventListener('click', closeDialog, { signal });
      });

      // ESC handled natively via <dialog> cancel event (no handler needed)
      openBtn.addEventListener('click', openDialog, { signal });

      dialog.dataset.sidePanelInit = 'true';
      window.__sidePanelInit[dialogId] = true;

      // Initialize any tabs inside this dialog
      initTabs(dialog, controller);
    }

    // Tabs: roving tabindex + arrow keys + show/hide panels
    function initTabs(container, controller) {
      const tabsRoot = container.querySelector('[data-tabs]');
      if (!tabsRoot || tabsRoot.dataset.tabsInit === 'true') return;

      const signal = controller?.signal;
      const tablist = tabsRoot.querySelector('[role="tablist"]');
      if (!tablist) return;

      const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
      const panels = tabsRoot.querySelectorAll('[role="tabpanel"]');
      if (tabs.length === 0) return;

      function activateTab(idx, focus = true) {
        tabs.forEach((tab, i) => {
          const selected = i === idx;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          const panelId = tab.getAttribute('aria-controls');
          const panel = panelId && tabsRoot.querySelector('#' + CSS.escape(panelId));
          if (panel) {
            if (selected) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          }
        });
        if (focus) tabs[idx].focus();
      }

      // Click to activate
      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activateTab(idx, true), { signal });
        tab.addEventListener('keydown', (e) => {
          let nextIdx = null;
          switch (e.key) {
            case 'ArrowRight':
            case 'Right':
              nextIdx = (idx + 1) % tabs.length; break;
            case 'ArrowLeft':
            case 'Left':
              nextIdx = (idx - 1 + tabs.length) % tabs.length; break;
            case 'Home':
              nextIdx = 0; break;
            case 'End':
              nextIdx = tabs.length - 1; break;
          }
          if (nextIdx !== null) {
            e.preventDefault();
            activateTab(nextIdx, true);
          }
        }, { signal });
      });

      tabsRoot.dataset.tabsInit = 'true';
    }

    function initSidePanelsIn(container, controller) {
      wireSidePanel('ingredients-open-button', 'ingredients-dialog', container, controller);
      wireSidePanel('desc-benefit-open-button', 'desc-benefit-dialog', container, controller);
      wireSidePanel('howto-open-button', 'howto-dialog', container, controller);
    }

    // First load
    const controller = new AbortController();
    initSidePanelsIn(document, controller);

    // Theme Editor: handle section reloads
    document.addEventListener('shopify:section:load', function (evt) {
      const sectionRoot = evt.target;
      const sectionController = new AbortController();
      initSidePanelsIn(sectionRoot, sectionController);

      sectionRoot.addEventListener('shopify:section:unload', function () {
        sectionController.abort();
        sectionRoot.querySelectorAll('dialog.side-panel-dialog').forEach((dlg) => {
          delete dlg.dataset.sidePanelInit;
          if (dlg.id) delete window.__sidePanelInit[dlg.id];
        });
        sectionRoot.querySelectorAll('[data-tabs]').forEach((t) => {
          delete t.dataset.tabsInit;
        });
      }, { once: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
